export function weightedProgress(items) {
    let sum = 0;
    let weights = 0;
    for (const it of items) {
        const w = it.weight ?? 1;
        if (w <= 0)
            continue;
        sum += clamp01(it.progress) * w;
        weights += w;
    }
    return weights === 0 ? 0 : sum / weights;
}
export function taskProgress(t) {
    if (t.completed)
        return 1;
    if (t.countChecklist && t.checklistTotal)
        return clamp01((t.checklistDone ?? 0) / t.checklistTotal);
    return 0;
}
export function goalProgress(node) {
    if (node.measured !== undefined && node.measured !== null)
        return clamp01(node.measured);
    const parts = [...node.links, ...node.children.map((c) => ({ progress: goalProgress(c), weight: c.weight }))];
    return weightedProgress(parts);
}
/** Avance de un indicador respecto a su línea base y su meta (sirve para metas crecientes y decrecientes). */
export function indicatorProgress(baseline, target, current) {
    if (target === baseline)
        return current === target ? 1 : 0;
    return clamp01((current - baseline) / (target - baseline));
}
export function clamp01(n) {
    return Number.isFinite(n) ? Math.max(0, Math.min(1, n)) : 0;
}
//# sourceMappingURL=progress.js.map